import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="download-qrcode"
export default class extends Controller {
  static targets = ["image"];
  static values = {
    eventName: String,
    url: String,
  };

  declare imageTarget: HTMLImageElement;

  declare eventNameValue: string;
  declare urlValue: string;

  download() {
    window.location.href = this.urlValue;
  }
}
